import { _FooterFacebookIcon } from "./_FooterFacebookIcon";
import { _FooterInstagramIcon } from "./_FooterInstagramIcon";
import { _FooterTiktokIcon } from "./_FooterTiktokIcon";

interface Props {
  className?: string;
  backgroundColor?: string;
}

export const Footer = ({
  className = "",
  backgroundColor = "bg-[var(--fy-blue)]"
}: Props): JSX.Element => {
  return (
    <div className={`flex flex-col items-center justify-center px-[170px] pt-[75px] pb-20 relative ${backgroundColor} ${className}`}>
      <div className="flex flex-col items-center justify-center gap-[45px] relative self-stretch w-full flex-[0_0_auto]">
        <div className="inline-flex items-center justify-center gap-2.5 relative flex-[0_0_auto]">
          <div className="relative w-fit mt-[-1.00px] font-footer-title font-[number:var(--footer-title-font-weight)] text-[var(--fy-grey)] text-[length:var(--footer-title-font-size)] text-center tracking-[var(--footer-title-letter-spacing)] leading-[var(--footer-title-line-height)] whitespace-nowrap [font-style:var(--footer-title-font-style)]">
            Follow
          </div>
        </div>

        <div className="inline-flex items-center justify-center gap-[19px] relative flex-[0_0_auto]">
          <_FooterFacebookIcon />
          <_FooterInstagramIcon />
          <_FooterTiktokIcon />
        </div>

        <div className="inline-flex items-center justify-center gap-2.5 relative flex-[0_0_auto]">
          <p className="relative w-fit mt-[-1.00px] font-footer-info font-[number:var(--footer-info-font-weight)] text-[var(--fy-grey)] text-[length:var(--footer-info-font-size)] text-center tracking-[var(--footer-info-letter-spacing)] leading-[var(--footer-info-line-height)] [font-style:var(--footer-info-font-style)]">
            {new Date().getFullYear()} © CLEARY TV LTD. Registered in England &amp; Wales.
            <br />
            Company Registration Number 12031971. All Rights Reserved.
          </p>
        </div>
      </div>
    </div>
  );
}; 